module.exports = "<tr> <td style=width:25%>{%- productName %}</td> <td style=width:35%>{%- description %}</td> <td style=width:20% class=q-text-right>{%- unitsInPallet %}</td> <td style=width:20% class=q-text-right>{%- totalUnits %}</td> </tr>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/detailPageLookupHTML/renderTemplateForPackingSubRow.html
// module id = 1240
// module chunks = 1